module.exports = __webpack_public_path__ + "img/mobilealipay.3c59cc31.svg";